import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

interface Props {
  value: string;
  error?: string;
  onChange: (field: string, value: any) => void;
}

function CompanyName({ value, error, onChange }: Props) {
  const classes = useStyles();

  const handleChangeDisplayName = (e: any) => {
    const value = e.target.value;
    onChange('client.displayName', value);
  };

  return (
    <>
      <Typography variant="h6">Company Name</Typography>
      <Typography variant="subtitle2">
        Your Company Name will be displayed to users throughout the platform.
      </Typography>
      <TextField
        id="company name"
        value={value}
        onChange={handleChangeDisplayName}
        helperText={error}
        error={!!error}
        inputProps={{ 'aria-label': 'company name', maxLength: 50 }}
        className={classes.input}
      />
    </>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  input: {
    minWidth: 250,
    marginBottom: theme.spacing(3),
  },
}));

export default CompanyName;
